import { useQuery } from 'react-query';
import { fetchOrganizationSettings } from '../services/settingsAPI';
import { queryKeys } from '../utils/queryKeys';

export const ORGANIZATION_SETTINGS_KEY = queryKeys.settings.organization;

/** Shared org settings (logo, name, address…) — same cache as Paramètres. */
export default function useOrganizationSettings(options = {}) {
  return useQuery(ORGANIZATION_SETTINGS_KEY, fetchOrganizationSettings, {
    staleTime: 60_000,
    refetchOnWindowFocus: true,
    ...options,
  });
}
